module.exports = __webpack_public_path__ + "static/media/joffre-14.cce3cdc8.jpg";